// Ponesi Coins client helpers. The backend is the ONLY authority for balances, coin totals and
// eligibility; these helpers are display-only.
export const COIN_PM = "PONESI_COINS";

export const fmtCoins = (n, locale = "sr") =>
  new Intl.NumberFormat(locale === "en" ? "en-US" : "sr-RS").format(Math.round(Number(n) || 0));

// Canonical restaurant-defined coin price of a product/modifier, or null (never derived from RSD).
export const coinPriceOf = (doc) => {
  if (!doc || !doc.coin_enabled) return null;
  const v = Number(doc.coin_price);
  return Number.isFinite(v) && v > 0 ? Math.round(v) : null;
};

export const isCoinOrder = (order) => (order || {}).payment_method === COIN_PM;
